export const API = "https://api.beleggersprofiel.omega.optimize-it.be/api";
export const AUTH_TOKEN = "beleggersProfielToken";
export const BEARER = "Bearer";
